import $ from 'jquery';

/* Play videos on Section Promo Video

- When clicking 'Watch video'-button on a Section Promo Video,
the embedded youtube video element will appear on front of the section and autoplay.

*/

Drupal.behaviors.troaxPlayVideo = {
  attach() {
    $('.promo-video')
      .once('troaxPlayVideo')
      .each((index, element) => this.attachToPromo(element));
  },

  attachToPromo(element) {
    const video = $(element).find('iframe');
    const videoLoop = $(element).find('.promo-video__loop');
    const videoContent = $(element).find('.promo-video__content');
    const playButton = $(element).find('.button--play-video');

    function playVideo() {
      videoLoop.css('display', 'none');
      videoContent.css('display', 'none');
      video.attr('allow', 'autoplay');
      video.attr('src', video.attr('src').replace('autoplay=0', 'autoplay=1'));
    }

    playButton.on('click', playVideo);
  },
};
